export { getDocument, getDocumentStyles, getLocation } from './globals';
